import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenAwalRanapKeperawatan";

interface SimpleUser {
  id: number;
  nama?: string;
}

interface Data {
  id: number;
  register_id: number;
  pasien_rm: string;
  unit_id: string;
  type: string;
  version: string;
  // Seluruh isi asesmen keperawatan disimpan di blob `content`
  // (lihat tabel asesmen_awal_ranap_keperawatan — kolom json `content`).
  content: Record<string, unknown>;
  examined_at: string;
  perawat_user_id: number;
  perawat: SimpleUser;
  dpjp_user_id: number;
  dpjp: SimpleUser;
  ppja_user_id: number;
  ppja: SimpleUser;
  dpjp_verified_at: string;
  ppja_verified_at: string;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-awal-ranap-keperawatan"
})
class AsesmenAwalRanapKeperawatanStore extends VuexModule {
  loading = false;
  asesmen: Data = null;
  isAnyUnsavedChange = false;

  @Mutation
  SET_RECORD(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.asesmen = null;
    this.isAnyUnsavedChange = false;
    this.loading = false;
  }

  @Mutation
  SET_IS_ANY_UNSAVED_CHANGE(val) {
    this.isAnyUnsavedChange = val;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    const list = response.data?.data ?? [];
    const dewasa = list.filter(item => item && item.type === "dewasa");
    this.SET_RECORD(dewasa.length ? dewasa[dewasa.length - 1] : null);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }

  @Action({ rawError: true })
  setIsAnyUnsavedChange(val): void {
    this.SET_IS_ANY_UNSAVED_CHANGE(val);
  }
}

export default getModule(AsesmenAwalRanapKeperawatanStore);
